import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { Chart, Widgets } from "../../../../Constants/Constants";
import TotalSale from "./TotalSale";
import MonthlyHistory from "./MonthlyHistory";
import SkillStatus from "./SkillStatus";
import OrderStatus from "./OrderStatus";
import LiveProducts from "./LiveProducts";
import Turnover from "./Turnover";
import CryptocurrencyPrices from "./CryptocurrencyPrices";
import CryptoAnnotations from "./CryptoAnnotations";
import StockMarket from "./StockMarket";
import Finance from "./Finance";
import OrderStatusWidgets from "./OrderStatusWidgets";
import MonthlySales from "./MonthlySales";
import UsesWidgets from "./UsesWidgets";

const ChartContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Chart} parent={Widgets} />
      <Container fluid>
        <Row>
          <TotalSale />
        </Row>
        <Row>
          <MonthlyHistory />
          <SkillStatus />
          <OrderStatus />
        </Row>
        <Row>
          <LiveProducts />
          <Turnover />
          <CryptocurrencyPrices />
          <CryptoAnnotations />
        </Row>
        <Row>
          <StockMarket />
          <Finance />
          <OrderStatusWidgets />
          <MonthlySales />
          <UsesWidgets />
        </Row>
      </Container>
    </>
  );
};

export default ChartContainer;
